
import {apiCollection, apiIndustryDel, apiIndustryLists} from "@/api/IndustryRequests";
import {apiNewsShopLists} from '@/api/shop'
import {Component, Vue} from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import LsDialog from "@/components/ls-dialog.vue";
import {RequestPaging} from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import {apiOtherLists} from "@/api/order";

@Component({
  components: {
    lsPagination,
    ExportData,
    LsDialog,
    DatePicker,
  },
})
export default class ShopList extends Vue {
  /** S Data **/

  apiShopLists = apiIndustryLists;

  importDialogVisible = false;
  importForm = {
    sid: '',
    keyword: '',
    type: 1,
    limit: '1',
    number: '10',
    initial_time: '',
  };

  pager: RequestPaging = new RequestPaging();
  shopData: any[] = []
  searchObj = {
    sid: "",
    cumulative: "",
    goods: "",
    buyer: "",
    tel: "",
  };
  otherLists: any = {
    set_meal: [],
    pay_status: [],
    pay_way: [],
  };


  /** S Methods **/
  // 确认采集
  async confirmImport() {
    if (!this.importForm.sid) {
      this.$message.error('请选择商户');
      return;
    }
    if (!this.importForm.keyword) {
      this.$message.error('请输入关键字');
      return;
    }
    if (!this.importForm.limit) {
      this.$message.error('请输入上传时间间隔值（分钟）');
      return;
    }
    if (!this.importForm.number) {
      this.$message.error('请输入采集条数');
      return;
    }
    if (!this.importForm.initial_time) {
      this.$message.error('请输入上传初始时间');
      return;
    }
    // 添加锁定机制，防止重复点击
    const confirmButton = document.querySelector('.el-dialog__footer .el-button--primary');
    if (confirmButton) {
      confirmButton.classList.add('is-loading');
      confirmButton.setAttribute('disabled', 'disabled');
    }

// 这里调用采集接口
    console.log('采集参数:', this.importForm);
    try {
      // 这里需要添加实际的导入API
      await apiCollection(this.importForm);
      // this.$message.success('导入成功');
      this.importDialogVisible = false;
      await this.getShopLists();
    } catch (error) {
      this.$message.error('失败');
    } finally {
      // 无论成功或失败，都要解锁按钮
      if (confirmButton) {
        confirmButton.classList.remove('is-loading');
        confirmButton.removeAttribute('disabled');
      }
    }

  }

  /** E Data **/
  //获取商场列表数据
  async getShopListsFn(): Promise<void> {
    const res: any = await apiNewsShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.data;
  }

  /** S Methods **/
  // 获取订单其他 方式数据
  getOtherMethodList() {
    apiOtherLists().then((res: any) => {
      this.otherLists = res;
    });
  }

  // 获取行业视频列表
  getShopLists(): void {
    this.pager.request({
      callback: apiIndustryLists,
      params: {
        ...this.searchObj,
        type: 1,
      },
    });
  }

  // 修改行业视频状态
  async shopSwitchStatusEdit(status: number, id: number): Promise<void> {
    // await apiShopSwitchStatus({ id });
    this.getShopLists();
  }
// 删除行业视频
  async onShopDelete(row: any): Promise<void> {
    await apiIndustryDel({id: row.id});
    this.getShopLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getShopLists();
  }


  // 去编辑行业视频
  toShopEdit(id: number | any): void {
    this.$router.push({
      path: "/IndustryVideo/lists_detail",
      query: {
        id: id,
      },
    });
  }


  // 去商家后台
  /** E Methods **/

  /** S ods **/
  created() {
    this.getShopLists();
    this.getOtherMethodList();

    // 获取商城列表是数据
    this.getShopListsFn()
  }
}
